export default __webpack_public_path__ + "static/media/icon_oil.96957d96.svg";